var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Store, Mutation } from "./annotations";
import { User } from "@pjn/core/model/app/User";
/**
 * Store que administra la seguridad y guarda el estado centralizado de la misma.
 */
let AuthStore = class AuthStore extends Vue {
    constructor() {
        super(...arguments);
        /** Usuario actual */
        this.user = null;
        /** Estado de carga del usuario (para mostrar loader) */
        this.status = {};
        /** Roles del usuario Actual  */
        this.roles = [];
    }
    setService(service) {
        this.authService = service;
    }
    /**
     * Indica si el usuario esta autenticado o no.
     */
    get authenticated() {
        return !!this.user;
    }
    /**
     * Devuelve el nombre a mostrar en caso de estar autenticado
     */
    get displayName() {
        return this.user ? this.user.displayName : undefined;
    }
    /**
     * Devuelve el nombre de usuario en caso de estar autentica
     */
    get username() {
        return this.user ? this.user.username : undefined;
    }
    /**
     * Realiza el login del usuario y guarda el estado (fuerza el login).
     */
    async login() {
        this.loginRequest();
        try {
            const user = await this.authService.login();
            const roles = this.authService.applicationRoles;
            this.loginSuccess(user, roles);
            // this.$emit('login', {user, roles});
            return { user, roles };
        }
        catch (e) {
            this.loginFail();
            return null;
        }
    }
    /**
     * Actualiza el estado solo en caso de que ya este autenticado (no fuerza login).
     * @returns Una promise que incluye los datos del usuario y roles si esta autenticado o null si no lo esta.
     */
    async loginIfAuthenticated() {
        const authenticated = await this.authService.check();
        if (authenticated)
            return this.login();
        return null;
    }
    /**
     * Realiza el logout y actualiza el estado.
     */
    async logout() {
        await this.authService.logout();
        this.logoutSuccess();
        // this.$emit('logout');
    }
    loginRequest() {
        this.status = { loading: true };
    }
    loginSuccess(user, roles) {
        this.status = {};
        this.user = user;
        this.roles = roles;
    }
    loginFail() {
        this.status = { error: true };
        this.user = null;
        this.roles = [];
    }
    logoutSuccess() {
        this.user = null;
        this.roles = [];
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthStore.prototype, "loginRequest", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [User, Array]),
    __metadata("design:returntype", void 0)
], AuthStore.prototype, "loginSuccess", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthStore.prototype, "loginFail", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthStore.prototype, "logoutSuccess", null);
AuthStore = __decorate([
    Store
], AuthStore);
export { AuthStore };
//# sourceMappingURL=AuthStore.js.map